import { getTileRoot } from './env';

export interface TiledPeriodManifest {
  periods: string[];
  periodKind?: string;
}

/** Period keys returned by GET /tiles/{layer}/periods (manifest entries with MBTiles on disk). */
export async function fetchTiledPeriodManifest(tileLayer: string): Promise<TiledPeriodManifest> {
  const tileRoot = getTileRoot();
  if (!tileRoot) return { periods: [] };

  try {
    const res = await fetch(`${tileRoot}/tiles/${tileLayer}/periods`);
    if (!res.ok) return { periods: [] };
    const data = await res.json();
    const periods = (data.periods ?? [])
      .map((entry: { period_start?: string }) => entry.period_start)
      .filter((p: string | undefined): p is string => Boolean(p));
    return { periods, periodKind: data.period_kind };
  } catch {
    return { periods: [] };
  }
}

export async function fetchTiledPeriodStarts(tileLayer: string): Promise<string[]> {
  const { periods } = await fetchTiledPeriodManifest(tileLayer);
  return periods;
}

export function periodKindPillLabel(periodKind?: string): string {
  if (periodKind === 'weekly') return 'Weeks';
  if (periodKind === 'monthly') return 'Months';
  return 'Periods';
}

/** True when period_start is a 4-digit calendar year (flood yearly slices). */
export function isFloodYearPeriod(period: string): boolean {
  return /^\d{4}$/.test(period);
}
